import { FrameAdvisorKeys, FrameGeniusExcludedPages } from '@/enums/frame-genius'
import { ENDPOINT_NAME, START_QUERY_PARAM } from '@/scripts/constants/frame-advisor'
import { REF } from '@/scripts/constants/parameters'
import wcs from '@/scripts/libs/wcs'
import { SuggestedFeatures } from '@/types/frame-genius'
export class FrameAdvisor {
  private static FRAME_ADVISOR_PICTURE_MODE_HASH_PATH = '#/picture-mode'

  static saveSessionData = (data: unknown) => {
    const encodedData = JSON.stringify(data)
    sessionStorage.setItem(FrameAdvisorKeys.SESSION_DATA, encodedData)
    localStorage.setItem(FrameAdvisorKeys.SESSION_DATA, encodedData)
  }

  static getSessionData = () => {
    const sessionStorageSessionData = sessionStorage.getItem(FrameAdvisorKeys.SESSION_DATA)
    const localStorageSessionData = localStorage.getItem(FrameAdvisorKeys.SESSION_DATA)
    return (
      (sessionStorageSessionData && JSON.parse(sessionStorageSessionData)) ||
      (localStorageSessionData && JSON.parse(localStorageSessionData))
    )
  }

  static wasFrameAdvisorPreviouslyInitialized = () => {
    const sessionStoragFrameAdvisorKeysInitialized = sessionStorage.getItem(
      FrameAdvisorKeys.INITIALIZED
    )
    const localStorageStoragFrameAdvisorKeysInitialized = localStorage.getItem(
      FrameAdvisorKeys.INITIALIZED
    )
    const wasItInitialized =
      sessionStoragFrameAdvisorKeysInitialized || localStorageStoragFrameAdvisorKeysInitialized
    return wasItInitialized === 'true'
  }

  static setFrameAdvisorInitializedStatus = (status: boolean) => {
    sessionStorage.setItem(FrameAdvisorKeys.INITIALIZED, `${status}`)
    localStorage.setItem(FrameAdvisorKeys.INITIALIZED, `${status}`)
  }

  static setFloatingButtonMinimizedState = (isMinimized: boolean) => {
    sessionStorage.setItem(FrameAdvisorKeys.FLOATING_BUTTON_MINIMIZED, `${isMinimized}`)
    localStorage.setItem(FrameAdvisorKeys.FLOATING_BUTTON_MINIMIZED, `${isMinimized}`)
  }

  static isFloatingButtonMinimized = () => {
    const sessionStorageFloatingButton = sessionStorage.getItem(
      FrameAdvisorKeys.FLOATING_BUTTON_MINIMIZED
    )
    const localStorageFloatingButton = localStorage.getItem(
      FrameAdvisorKeys.FLOATING_BUTTON_MINIMIZED
    )
    const isMinimized = sessionStorageFloatingButton || localStorageFloatingButton
    return isMinimized === 'true'
  }

  private static isUserInExcludedPage = () => {
    const { viewTaskName } = wcs.getStoreConfig()
    return FrameGeniusExcludedPages.includes(viewTaskName)
  }

  static needsReinit = () => {
    const { frameGenius } = wcs.getStoreConfig()

    const wasFrameAdvisorInitializedAndNotExcludedPage =
      FrameAdvisor.wasFrameAdvisorPreviouslyInitialized() && !FrameAdvisor.isUserInExcludedPage()

    return frameGenius.isFloatingButtonFeatureEnabled
      ? FrameAdvisor.isFloatingButtonMinimized() && wasFrameAdvisorInitializedAndNotExcludedPage
      : wasFrameAdvisorInitializedAndNotExcludedPage
  }

  static setAnalysisResults = (suggestedFeatures: SuggestedFeatures) => {
    if (!suggestedFeatures) {
      return
    }
    const stringifiedSuggestedFeatures = JSON.stringify(suggestedFeatures)
    sessionStorage.setItem(FrameAdvisorKeys.ANALYSIS_RESULTS, `${stringifiedSuggestedFeatures}`)
    localStorage.setItem(FrameAdvisorKeys.ANALYSIS_RESULTS, `${stringifiedSuggestedFeatures}`)
  }

  static getAnalysisResults = (): SuggestedFeatures => {
    const stringifiedSuggestedFeatures =
      localStorage.getItem(FrameAdvisorKeys.ANALYSIS_RESULTS) ||
      sessionStorage.getItem(FrameAdvisorKeys.ANALYSIS_RESULTS) ||
      '{}'
    const suggestedFeatures = JSON.parse(stringifiedSuggestedFeatures)
    return suggestedFeatures
  }
  static addPictureModeHashPath = () => {
    window.location.hash = FrameAdvisor.FRAME_ADVISOR_PICTURE_MODE_HASH_PATH
  }

  static canStartFrameAdvisor = () => {
    const queryParams = new URLSearchParams(window.location.search)
    const isStartFrameAdvisorQueryParam = queryParams.get(REF) === START_QUERY_PARAM

    return FrameAdvisor.isInFrameAdvisorPage() && isStartFrameAdvisorQueryParam
  }

  static isInFrameAdvisorPage = () => {
    const URL = `${window.location.origin}${window.location.pathname}`
    const isInFrameAdvisorPage = URL === wcs.getEndPoint(ENDPOINT_NAME)

    return isInFrameAdvisorPage
  }
}
